// angular
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '@app/core/components/button/button.component';
import { COMPANY_WHATSAPP_LINK } from '@app/shared/constants/company-contact.const';

@Component({
  selector: 'pwj-tender-support-card',
  standalone: true,
  imports: [TranslateModule, ButtonComponent],
  templateUrl: './tender-support-card.component.html',
  styleUrl: './tender-support-card.component.scss',
})
export class TenderSupportCardComponent {
  contactLink = COMPANY_WHATSAPP_LINK;
}
